import { ThemeDto, ThemesApi } from '@coretava/api/core-service';
import {
  action, computed, makeAutoObservable, observable, runInAction, when,
} from 'mobx';
import { createCoreAxios, getBaseConfig } from '../../utils/api-helper';
import { AppStore } from '../app';

class ThemeStore {
  @observable theme?: ThemeDto = undefined;

  @observable initialized = false;

  constructor() {
    makeAutoObservable(this);

    void this.initialize();
  }

  @computed
  get api(): ThemesApi {
    // Use axios instance with token refresh interceptor
    return new ThemesApi(
      getBaseConfig(),
      undefined,
      createCoreAxios(),
    );
  }

  @action
  public async initialize(): Promise<void> {
    await when(() => !!AppStore.app);

    if (AppStore.app) {
      const response = await this.api.themesControllerGetByApp({ gamixAppId: AppStore.app.id });

      if (response.data.theme) {
        runInAction(() => {
          this.theme = response.data.theme;
          this.initialized = true;
        });
      }
    }
  }
}

export default new ThemeStore();
